module.exports = __webpack_public_path__ + "img/PHARMACY_INFO.72debed7.svg";